import React from 'react'
import CustomCard from '../../../../../reusableComponents/cards/Card61'
import Placeholder1 from '../../../../../../assets/learnings/courses/AvailableCoursesPlaceholder/Placeholder1.jpeg'
import Placeholder2 from '../../../../../../assets/learnings/courses/AvailableCoursesPlaceholder/Placeholder2.jpeg'
import Placeholder3 from '../../../../../../assets/learnings/courses/AvailableCoursesPlaceholder/Placeholder3.jpeg'
import Placeholder4 from '../../../../../../assets/learnings/courses/AvailableCoursesPlaceholder/Placeholder4.jpeg'


const TutorComponent = ({ tutorName = "Tutor name" }) => {
    return (
        <div className="w-full self-stretch inline-flex justify-start items-center gap-2">
            <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gray-200" />
            <div className="justify-center text-zinc-800 text-xs sm:text-sm font-circular font-[450] leading-normal truncate">{tutorName}</div>
        </div>
    )
}

const AvailableCourseCard = () => {
    // Sample courses data with tutor names and public image URLs
    const courses = [
        {
            title: "Learn Sketch",
            duration: "4h 32min",
            tutorName: "John Smith",
            image: {
                src: Placeholder1,
                alt: "Learn Sketch Course"
            }
        },
        {
            title: "Learn Angular Fundamentals",
            duration: "4h 32min",
            tutorName: "Emily Chen",
            image: {
                src: Placeholder2,
                alt: "Angular Fundamentals Course"
            }
        },
        {
            title: "Build A Portfolio Website",
            duration: "4h 32min",
            tutorName: "Michael Johnson",
            image: {
                src: Placeholder3,
                alt: "Build Portfolio Website Course"
            }
        },
        {
            title: "Learn Photoshop",
            duration: "4h 32min",
            tutorName: "Sarah Williams",
            image: {
                src: Placeholder4,
                alt: "Learn Photoshop Course"
            }
        }
    ]

    return (
        <>
            <div className="w-full">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
                    {courses.map((course, index) => (
                        <div key={index} className="w-full">
                            <CustomCard
                                width="w-full"
                                showImage={true}
                                image={course.image} // Change imageUrl to image
                                showBadge={false}
                                showLabel1={false}
                                showLabel2={false}
                                title={course.title}
                                description=""
                                showSwapComponent1={true}
                                swapComponent1={<TutorComponent tutorName={course.tutorName} />}
                                showSwapComponent2={false}
                                showSwapComponent3={false}
                                showFooter={true}
                                showRight={false}
                                showDuration={true}
                                durationText={course.duration}
                                className="hover:cursor-pointer"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default AvailableCourseCard